// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/debts.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { DateSchedule } from "../../optimizer/v1/date_schedule";
import { Date } from "./date";
/**
 * @generated from protobuf message core.v1.Loan
 */
export interface Loan {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: optional double balance = 3;
     */
    balance?: number;
    /**
     * @generated from protobuf field: optional double interest = 4;
     */
    interest?: number; // annual rate, percent
    /**
     * @generated from protobuf field: core.v1.LoanType type = 5;
     */
    type: LoanType;
    /**
     * @generated from protobuf field: optional double existing_monthly_payment = 6;
     */
    existingMonthlyPayment?: number; // current habit; read only by the current-trajectory run
    /**
     * @generated from protobuf field: core.v1.Date last_known_accruement_date = 8;
     */
    lastKnownAccruementDate?: Date;
    /**
     * @generated from protobuf field: core.v1.Date last_known_payment_due_date = 9;
     */
    lastKnownPaymentDueDate?: Date;
    /**
     * @generated from protobuf field: core.v1.Date end_payment_date = 11;
     */
    endPaymentDate?: Date;
    /**
     * @generated from protobuf field: optimizer.v1.DateSchedule min_payment_schedule = 22;
     */
    minPaymentSchedule?: DateSchedule;
    /**
     * @generated from protobuf field: optimizer.v1.DateSchedule accruement_schedule = 23;
     */
    accruementSchedule?: DateSchedule;
}
/**
 * A mortgage on a Property. The property's value, taxes and insurance live on the Property.
 *
 * @generated from protobuf message core.v1.Mortgage
 */
export interface Mortgage {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: optional double balance = 3;
     */
    balance?: number;
    /**
     * @generated from protobuf field: optional double interest = 4;
     */
    interest?: number; // annual rate, percent
    /**
     * @generated from protobuf field: string property_uuid = 5;
     */
    propertyUuid: string; // the Property this mortgage is secured on
    /**
     * @generated from protobuf field: core.v1.Date purchase_date = 10;
     */
    purchaseDate?: Date; // start of the current amortization (purchase, or last reamortization)
    /**
     * @generated from protobuf field: core.v1.Lender lender = 12;
     */
    lender: Lender;
    /**
     * @generated from protobuf field: core.v1.Date last_known_payment_due_date = 13;
     */
    lastKnownPaymentDueDate?: Date;
    /**
     * @generated from protobuf field: core.v1.Date last_known_accruement_date = 16;
     */
    lastKnownAccruementDate?: Date;
    /**
     * @generated from protobuf field: optional double down_payment = 17;
     */
    downPayment?: number;
    /**
     * @generated from protobuf field: core.v1.Date last_reamortization_date = 20;
     */
    lastReamortizationDate?: Date;
    /**
     * @generated from protobuf field: optimizer.v1.DateSchedule min_payment_schedule = 22;
     */
    minPaymentSchedule?: DateSchedule;
    /**
     * @generated from protobuf field: optimizer.v1.DateSchedule accruement_schedule = 23;
     */
    accruementSchedule?: DateSchedule;
    /**
     * @generated from protobuf oneof: terms
     */
    terms: {
        oneofKind: "remainingAmortizationMonths";
        /**
         * @generated from protobuf field: int32 remaining_amortization_months = 24;
         */
        remainingAmortizationMonths: number;
    } | {
        oneofKind: "existingMonthlyPayment";
        /**
         * @generated from protobuf field: double existing_monthly_payment = 25;
         */
        existingMonthlyPayment: number;
    } | {
        oneofKind: "amortizationPeriod";
        /**
         * @generated from protobuf field: int32 amortization_period = 26;
         */
        amortizationPeriod: number; // legacy: total amortization in years from purchase_date
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message core.v1.CreditCard
 */
export interface CreditCard {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: optional double balance = 3;
     */
    balance?: number;
    /**
     * @generated from protobuf field: optional double interest = 4;
     */
    interest?: number;
    /**
     * @generated from protobuf field: core.v1.Date last_known_accruement_date = 6;
     */
    lastKnownAccruementDate?: Date;
    /**
     * @generated from protobuf field: core.v1.Date last_known_payment_due_date = 7;
     */
    lastKnownPaymentDueDate?: Date;
    /**
     * @generated from protobuf field: optional double existing_monthly_payment = 9;
     */
    existingMonthlyPayment?: number;
    /**
     * @generated from protobuf field: optimizer.v1.DateSchedule min_payment_schedule = 10;
     */
    minPaymentSchedule?: DateSchedule;
    /**
     * @generated from protobuf field: optimizer.v1.DateSchedule accruement_schedule = 11;
     */
    accruementSchedule?: DateSchedule;
    /**
     * @generated from protobuf field: optional double credit_limit = 12;
     */
    creditLimit?: number;
}
/**
 * @generated from protobuf enum core.v1.Lender
 */
export enum Lender {
    /**
     * @generated from protobuf enum value: LENDER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: LENDER_NATIONAL_BANK = 1;
     */
    NATIONAL_BANK = 1,
    /**
     * @generated from protobuf enum value: LENDER_RBC = 2;
     */
    RBC = 2,
    /**
     * @generated from protobuf enum value: LENDER_TD = 3;
     */
    TD = 3,
    /**
     * @generated from protobuf enum value: LENDER_SCOTIABANK = 4;
     */
    SCOTIABANK = 4,
    /**
     * @generated from protobuf enum value: LENDER_BMO = 5;
     */
    BMO = 5,
    /**
     * @generated from protobuf enum value: LENDER_CIBC = 6;
     */
    CIBC = 6,
    /**
     * @generated from protobuf enum value: LENDER_OTHER = 7;
     */
    OTHER = 7
}
/**
 * @generated from protobuf enum core.v1.LoanType
 */
export enum LoanType {
    /**
     * @generated from protobuf enum value: LOAN_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: LOAN_TYPE_LINE_OF_CREDIT = 1;
     */
    LINE_OF_CREDIT = 1,
    /**
     * @generated from protobuf enum value: LOAN_TYPE_CREDIT_CARD = 2;
     */
    CREDIT_CARD = 2,
    /**
     * @generated from protobuf enum value: LOAN_TYPE_PERSONAL_LOAN = 3;
     */
    PERSONAL_LOAN = 3,
    /**
     * @generated from protobuf enum value: LOAN_TYPE_STUDENT_LOAN = 4;
     */
    STUDENT_LOAN = 4,
    /**
     * @generated from protobuf enum value: LOAN_TYPE_CAR_LOAN = 5;
     */
    CAR_LOAN = 5,
    /**
     * @generated from protobuf enum value: LOAN_TYPE_OTHER = 6;
     */
    OTHER = 6,
    /**
     * @generated from protobuf enum value: LOAN_TYPE_CRA_DEBT = 7;
     */
    CRA_DEBT = 7,
    /**
     * @generated from protobuf enum value: LOAN_TYPE_FAMILY_LOAN = 8;
     */
    FAMILY_LOAN = 8,
    /**
     * @generated from protobuf enum value: LOAN_TYPE_BUY_NOW_PAY_LATER = 9;
     */
    BUY_NOW_PAY_LATER = 9,
    /**
     * @generated from protobuf enum value: LOAN_TYPE_BUSINESS_LOAN = 10;
     */
    BUSINESS_LOAN = 10
}
// @generated message type with reflection information, may provide speed optimized methods
class Loan$Type extends MessageType<Loan> {
    constructor() {
        super("core.v1.Loan", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "balance", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "interest", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "type", kind: "enum", T: () => ["core.v1.LoanType", LoanType, "LOAN_TYPE_"] },
            { no: 6, name: "existing_monthly_payment", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "last_known_accruement_date", kind: "message", T: () => Date },
            { no: 9, name: "last_known_payment_due_date", kind: "message", T: () => Date },
            { no: 11, name: "end_payment_date", kind: "message", T: () => Date },
            { no: 22, name: "min_payment_schedule", kind: "message", T: () => DateSchedule },
            { no: 23, name: "accruement_schedule", kind: "message", T: () => DateSchedule }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Loan
 */
export const Loan = new Loan$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Mortgage$Type extends MessageType<Mortgage> {
    constructor() {
        super("core.v1.Mortgage", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "balance", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "interest", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "property_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "purchase_date", kind: "message", T: () => Date },
            { no: 12, name: "lender", kind: "enum", T: () => ["core.v1.Lender", Lender, "LENDER_"] },
            { no: 13, name: "last_known_payment_due_date", kind: "message", T: () => Date },
            { no: 16, name: "last_known_accruement_date", kind: "message", T: () => Date },
            { no: 17, name: "down_payment", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 20, name: "last_reamortization_date", kind: "message", T: () => Date },
            { no: 22, name: "min_payment_schedule", kind: "message", T: () => DateSchedule },
            { no: 23, name: "accruement_schedule", kind: "message", T: () => DateSchedule },
            { no: 24, name: "remaining_amortization_months", kind: "scalar", oneof: "terms", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "existing_monthly_payment", kind: "scalar", oneof: "terms", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 26, name: "amortization_period", kind: "scalar", oneof: "terms", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Mortgage
 */
export const Mortgage = new Mortgage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreditCard$Type extends MessageType<CreditCard> {
    constructor() {
        super("core.v1.CreditCard", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "balance", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "interest", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "last_known_accruement_date", kind: "message", T: () => Date },
            { no: 7, name: "last_known_payment_due_date", kind: "message", T: () => Date },
            { no: 9, name: "existing_monthly_payment", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "min_payment_schedule", kind: "message", T: () => DateSchedule },
            { no: 11, name: "accruement_schedule", kind: "message", T: () => DateSchedule },
            { no: 12, name: "credit_limit", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.CreditCard
 */
export const CreditCard = new CreditCard$Type();
